import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Chip,
  Paper,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import axios from "@/services/api/axios";
type Doc = { id: string; type: string; filename: string };
type Item = {
  id: string | null;
  entity_type: "TRADER" | "TEAM_LEAD";
  subject_id: string;
  subject_name: string | null;
  trader_id: string | null;
  trader_name: string | null;
  teamlead_id: string | null;
  username: string | null;
  telegram: string | null;
  status: string;
  submitted_at: string | null;
  review_comment: string | null;
  documents: Doc[];
};
const labels: Record<string, string> = {
  NOT_SUBMITTED: "Не предоставлены",
  PENDING: "Документы получены",
  APPROVED: "Одобрены",
  REJECTED: "Отклонены",
};
const entityLabels = { TRADER: "Трейдер", TEAM_LEAD: "Тимлид" } as const;
export default function Verification() {
  const [items, setItems] = useState<Item[]>([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const filteredItems = items.filter((item) => {
    const needle = search.trim().toLowerCase();
    return (!needle || [item.subject_name, item.username, item.telegram, item.subject_id].some((value) => value?.toLowerCase().includes(needle))) && (!status || item.status === status);
  });
  const load = async () => setItems((await axios.get("/verification")).data);
  useEffect(() => {
    load();
  }, []);
  const decide = async (i: Item, approved: boolean) => {
    if (!i.id) return;
    const comment = approved ? null : prompt("Причина отклонения") || null;
    await axios.post(`/verification/${i.id}/decision`, { approved, comment });
    await load();
  };
  const download = async (d: Doc) => {
    const r = await axios.get(`/verification/documents/${d.id}`, {
      responseType: "blob",
    });
    const u = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = u;
    a.download = d.filename;
    a.click();
    URL.revokeObjectURL(u);
  };
  return (
    <Box>
      <Typography variant="h4" mb={3}>
        Верификация
      </Typography>
      <Paper variant="outlined" sx={{ p: 2, mb: 2 }}><Stack direction={{ xs: "column", md: "row" }} spacing={2}><TextField fullWidth label="Поиск по имени, Telegram или ID" value={search} onChange={(event) => setSearch(event.target.value)} /><FormControl sx={{ minWidth: 220 }}><InputLabel>Статус</InputLabel><Select value={status} label="Статус" onChange={(event) => setStatus(event.target.value)}><MenuItem value="">Все</MenuItem>{Object.entries(labels).map(([value, label]) => <MenuItem key={value} value={value}>{label}</MenuItem>)}</Select></FormControl><Button onClick={() => { setSearch(""); setStatus(""); }}>Сбросить</Button></Stack></Paper>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Участник</TableCell>
              <TableCell>Статус</TableCell>
              <TableCell>Отправлено</TableCell>
              <TableCell>Документы</TableCell>
              <TableCell>Действия</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredItems.map((i) => (
              <TableRow key={`${i.entity_type}:${i.subject_id}`}>
                <TableCell>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <b>{i.subject_name || i.username}</b>
                    <Chip size="small" variant="outlined" label={entityLabels[i.entity_type]} />
                  </Stack>
                  <br />
                  {i.telegram && <small>{i.telegram}</small>}
                </TableCell>
                <TableCell>
                  <Chip
                    label={labels[i.status] || i.status}
                    color={
                      i.status === "APPROVED"
                        ? "success"
                        : i.status === "PENDING"
                          ? "warning"
                          : i.status === "REJECTED"
                            ? "error"
                          : "default"
                    }
                  />
                  {i.review_comment && (
                    <Typography variant="caption" display="block">
                      {i.review_comment}
                    </Typography>
                  )}
                </TableCell>
                <TableCell>
                  {i.submitted_at
                    ? new Date(i.submitted_at).toLocaleString()
                    : "—"}
                </TableCell>
                <TableCell>
                  {i.documents.length
                    ? i.documents.map((d) => (
                        <Button
                          key={d.id}
                          size="small"
                          onClick={() => download(d)}
                        >
                          {d.type === "PASSPORT" ? "Паспорт" : "Соглашение"}:{" "}
                          {d.filename}
                        </Button>
                      ))
                    : "—"}
                </TableCell>
                <TableCell>
                  {i.status === "PENDING" && (
                    <Box display="flex" gap={1}>
                      <Button
                        variant="contained"
                        color="success"
                        onClick={() => decide(i, true)}
                      >
                        Одобрить
                      </Button>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => decide(i, false)}
                      >
                        Отклонить
                      </Button>
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
